import React from 'react'
import { Checkbox, Input, Radio, Typography } from 'antd'
import { EEnhancementImageType } from 'models/product'
import { OrangeButton } from 'components/ui'
import { IAiEnhancementSettings, IAiProductPhoto } from '../types'
import styles from '../AiEnhancementModal.module.scss'
import { PhotoPicker } from './PhotoPicker'

interface IEnhancementSettingsProps {
  settings: IAiEnhancementSettings
  photos: IAiProductPhoto[]
  onChange: (patch: Partial<IAiEnhancementSettings>) => void
  onGenerate: () => void
}

const { TextArea } = Input

export const EnhancementSettings: React.FC<IEnhancementSettingsProps> = ({
  settings,
  photos,
  onChange,
  onGenerate
}) => (
  <div className={styles.enhanceSettings}>
    <Checkbox
      checked={settings.improveDescription}
      onChange={(e) => onChange({ improveDescription: e.target.checked })}
      className={styles.checkbox}
    >
      Улучшить описание
    </Checkbox>

    {settings.improveDescription && (
      <div className={styles.textareaWrapper}>
        <TextArea
          placeholder='Модификация промта'
          value={settings.descriptionPrompt}
          onChange={(e) => onChange({ descriptionPrompt: e.target.value })}
          autoSize={{ minRows: 2, maxRows: 4 }}
        />
      </div>
    )}

    <Checkbox
      checked={settings.productImage}
      onChange={(e) => onChange({ productImage: e.target.checked })}
      className={styles.checkbox}
    >
      Картинка товара
    </Checkbox>

    {settings.productImage && (
      <>
        <div className={styles.radioGroup}>
          <Radio.Group
            value={settings.imageType}
            onChange={(e) => onChange({ imageType: e.target.value })}
          >
            <Radio value={EEnhancementImageType.BACKGROUND} className={styles.radioOption}>
              Только замена фона
            </Radio>
            <Radio value={EEnhancementImageType.FULL} className={styles.radioOption}>
              Полное улучшение картинки
            </Radio>
            <Radio value={EEnhancementImageType.INFOGRAPHIC} className={styles.radioOption}>
              Полное улучшение + инфографика
            </Radio>
          </Radio.Group>
        </div>
        <div className={styles.textareaWrapper}>
          <TextArea
            placeholder='Модификация промта для изображения'
            value={settings.imagePrompt}
            onChange={(e) => onChange({ imagePrompt: e.target.value })}
            autoSize={{ minRows: 2, maxRows: 4 }}
          />
        </div>
        <Typography.Title level={5} className={styles.photoPickerTitle}>
          Выберите фото товара
        </Typography.Title>
        <PhotoPicker
          photos={photos}
          selectedPhoto={settings.selectedPhoto}
          onSelect={(photo) => onChange({ selectedPhoto: photo })}
        />
      </>
    )}

    <OrangeButton
      size='large'
      onClick={onGenerate}
      className={styles.generateButton}
    >
      Сгенерировать
    </OrangeButton>
  </div>
)
